
import { defineComponent } from "vue";
import links from "@/config/links";

export default defineComponent({
  data() {
    return {
      links,
    };
  },
  methods: {},
});
